
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/view",
      function () {
        return require("private-next-pages/guide/view.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/view"])
      });
    }
  